import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "main-body",
    "data-cy": "worker-wrapper"
};
const _hoisted_2 = { class: "header" };
const _hoisted_3 = { class: "mt-1 float-right body2-text" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DrawerToggleButton = _resolveComponent("DrawerToggleButton");
    const _component_WorkerStatus = _resolveComponent("WorkerStatus");
    const _component_Search = _resolveComponent("Search");
    const _component_WorkerList = _resolveComponent("WorkerList");
    return (_openBlock(), _createElementBlock("div", null, [
        _createCommentVNode(" 라이더 목록 접기 버튼 "),
        _createVNode(_component_DrawerToggleButton, {
            "test-id": "worker-toggle-btn",
            "is-reverse": true,
            "is-drawer-open": _ctx.isDrawerOpen,
            "on-click": _ctx.handleClickDrawerBtn
        }, null, 8 /* PROPS */, ["is-drawer-open", "on-click"]),
        _createElementVNode("div", _hoisted_1, [
            _createCommentVNode(" header "),
            _createElementVNode("div", _hoisted_2, [
                _createTextVNode(_toDisplayString(_ctx.$t('views.map_control.worker_wrapper.worker_list')) + " ", 1 /* TEXT */),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.lc + 'share_worker_state', [_ctx.isHideShareOrderOnOff])), 1 /* TEXT */)
            ]),
            _createCommentVNode(" 라이더 현황 "),
            _createVNode(_component_WorkerStatus, {
                "selected-worker-filter": _ctx.selectedWorkerFilter,
                "worker-total": _ctx.workerTotal,
                "on-click-worker-filter": _ctx.onClickWorkerFilter
            }, null, 8 /* PROPS */, ["selected-worker-filter", "worker-total", "on-click-worker-filter"]),
            _createCommentVNode(" 검색 "),
            _createVNode(_component_Search, {
                placeholder: _ctx.$t(_ctx.lc + 'search_placeholder'),
                "on-search": _ctx.onSearch
            }, null, 8 /* PROPS */, ["placeholder", "on-search"]),
            _createCommentVNode(" 라이더 리스트 "),
            _createVNode(_component_WorkerList, {
                class: "root-worker-list",
                "related-worker-list": _ctx.getterRelatedWorkerList,
                "main-worker-list": _ctx.getterMainWorkerList,
                "on-click-worker-item": _ctx.handleClickWorkerItem,
                "is-selected": _ctx.isSelectedWorker
            }, null, 8 /* PROPS */, ["related-worker-list", "main-worker-list", "on-click-worker-item", "is-selected"])
        ])
    ]));
}
